import styled from '@emotion/styled';
import { Field, Link, tokens } from '@hotjar/hotsauce';

export const PageSection = styled.div`
  width: 600px;
  margin-top: ${tokens.spacer.x6pt5};
`;

export const StyledField = styled(Field)`
  width: 100%;
  margin-bottom: ${tokens.spacer.x4};
  position: relative;
`;

export const AddNewButton = styled.span`
  position: absolute;
  top: 0;
  right: 0;
  color: ${tokens.color.secondary_cta};
  cursor: pointer;
  ${tokens.text('subtitle2')}
`;

export const ErrorMessage = styled.div`
  ${tokens.text('caption')}
  color: ${tokens.color.text_danger};
`;

export const ButtonLink = styled(Link)`
  text-decoration: initial;
  &:hover {
    text-decoration: underline;
  }
`;
